export default __webpack_public_path__ + "static/media/bp12.923e10b4.jpeg";